import { Trans } from 'react-i18next';

import { Alert, Anchor } from '@myphx-engineering/phx-design-system';

export interface RecoverPasswordGenericMessageErrorProps {
    onLinkClick: () => void;
    onContactUsClick: () => void;
}

export const RecoverPasswordGenericMessageError = (
    props: RecoverPasswordGenericMessageErrorProps
) => {
    const { onLinkClick, onContactUsClick } = props;

    return (
        <Alert data-testid="recover-generic-message-error" severity="error">
            <Trans i18nKey="formErrors.recoverPasswordGenericError">
                Something went wrong. Please{' '}
                <Anchor onClick={onLinkClick}>try again</Anchor> or{' '}
                <Anchor onClick={onContactUsClick}>contact us</Anchor>.
            </Trans>
        </Alert>
    );
};
